/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Visibility and access settings for the tournament
 * @export
 */
export const TournamentPrivacy = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    INVITE_ONLY: 'INVITE_ONLY'
} as const;
export type TournamentPrivacy = typeof TournamentPrivacy[keyof typeof TournamentPrivacy];


export function instanceOfTournamentPrivacy(value: any): boolean {
    for (const key in TournamentPrivacy) {
        if (Object.prototype.hasOwnProperty.call(TournamentPrivacy, key)) {
            if (TournamentPrivacy[key as keyof typeof TournamentPrivacy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentPrivacyFromJSON(json: any): TournamentPrivacy {
    return TournamentPrivacyFromJSONTyped(json, false);
}

export function TournamentPrivacyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrivacy {
    return json as TournamentPrivacy;
}

export function TournamentPrivacyToJSON(value?: TournamentPrivacy | null): any {
    return value as any;
}

export function TournamentPrivacyToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentPrivacy {
    return value as TournamentPrivacy;
}

